import { useState } from 'react';
import { Accordion } from '@diamond-design/components';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './accordionWrapper.module.scss';

function AccordionWrapper({
  id,
  head,
  body,
  containerStyle = '',
  headStyle = '',
  bodyStyle = '',
  borderTopHidden = false,
  borderBottom = false,
  expanded: initialExpanded = false,
  ...rest
}) {
  const [expanded, setExpanded] = useState(initialExpanded);

  const handleChange = (isExpanded) => {
    setExpanded(isExpanded);
  };

  return (
    <div className={styles.accordion}>
      <Accordion
        id={id}
        headerContent={head}
        /* eslint-disable-next-line react/no-children-prop */
        children={body}
        headerContentClass={classnames(styles.accordionItemHeader, headStyle)}
        containerClass={classnames(
          styles.accordionContainer,
          containerStyle,
          { [styles.borderBottom]: borderBottom },
          { [styles.borderTopHidden]: borderTopHidden }
        )}
        contentClass={classnames(styles.accordionContent, bodyStyle)}
        {...rest}
        expanded={expanded}
        onChange={handleChange}
      />
    </div>
  );
}
AccordionWrapper.propTypes = {
  id: PropTypes.string.isRequired,
  head: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  headStyle: PropTypes.string,
  containerStyle: PropTypes.string,
  bodyStyle: PropTypes.string,
  borderTopHidden: PropTypes.bool,
  borderBottom: PropTypes.bool,
  expanded: PropTypes.bool,
};

export default AccordionWrapper;
